import { render, staticRenderFns } from "./PortfolioManagerDetails.vue?vue&type=template&id=3d4f8ec5"
import script from "./PortfolioManagerDetails.vue?vue&type=script&lang=ts"
export * from "./PortfolioManagerDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports